export const MUC_OP_HOTLINE = "+49 (0) 30 4669 0996";
export const resolveHotline = (terminalCode, backendHotline) =>
    terminalCode === "MUC_OP" ? MUC_OP_HOTLINE : backendHotline;
